import * as React from 'react';
import { Api } from '../../../typings/api';
import { SharedDocumentsContainer, SharedDocumentsContent } from './styles';
import DriveItemUtils from '../../../utils/driveItem';

interface SharedDocumentsProps {
	selection: Api.DriveItem[];
}

const renderSelectionContent = (selection: Api.DriveItem[]) => {
	return selection.map(
		(driveItem, index) => (
			<SharedDocumentsContent key={index}>
				{DriveItemUtils.getDisplayName(driveItem)}
			</SharedDocumentsContent>
		)
	);
};

const SharedDocuments = (props: SharedDocumentsProps) => {
	return (
		<SharedDocumentsContainer>
			{renderSelectionContent(props.selection)}
		</SharedDocumentsContainer>
	);
};

export default SharedDocuments;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/SharedDocuments/index.tsx